import React, { useEffect } from 'react';

/**
 * Animated dots component for loading states
 * Shows three dots that appear sequentially in a loop
 */
const AnimatedDots = () => {
  useEffect(() => {
    // Inject CSS animation for sequential dots
    const style = document.createElement('style');
    style.textContent = `
      @keyframes dotSequence {
        0%, 20% { opacity: 0; }
        50% { opacity: 1; }
        100% { opacity: 0; }
      }
      .dot-1 { animation: dotSequence 1.5s infinite; }
      .dot-2 { animation: dotSequence 1.5s infinite 0.5s; }
      .dot-3 { animation: dotSequence 1.5s infinite 1s; }
    `;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <span className="inline-flex text-neutral-500 dark:text-neutral-400">
      <span className="dot-1">.</span>
      <span className="dot-2">.</span>
      <span className="dot-3">.</span>
    </span>
  );
};

export default AnimatedDots;
